import { configureStore } from "@reduxjs/toolkit";
import { carsReducer } from "./slices/carsTrucks.slice";
import { atvsUtvsReducer } from "./slices/atvsUtvs.slice";
import { snowmobilesReducer } from "./slices/snowmobiles.slice";
import { watercraftsReducer } from "./slices/watercrafts.slice";
import { classicCollectorCarsReducer } from "./slices/classicCollectorCars.slice";
import { motorcyclesReducer } from "./slices/motorcycles.slice";
import { rvsReducer } from "./slices/rvs.slice";
import { heavyEquipmentsReducer } from "./slices/heavyEquipments.slice";

export const store = configureStore({
  reducer: {
    cars: carsReducer,
    atvsUtvs: atvsUtvsReducer,
    snowmobiles: snowmobilesReducer,
    watercrafts: watercraftsReducer,
    classicCollectorCars: classicCollectorCarsReducer,
    motorcycles: motorcyclesReducer,
    rvs: rvsReducer,
    heavyEquipments: heavyEquipmentsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
